import React, { useState } from 'react';
import { database } from '../Firebase/firebase';
import { v4 as uuidv4 } from 'uuid';

import { firebaseCollections } from '../Constants/Variables';
import Avatar from 'react-avatar';

import Comment from './Comment';

import '../Styles/Components/Comments.scss';

export default function Comments(props) {

    const [enteredText, setEnteredText] = useState("");
    var post = props.post;
    var comments = post.comments;
    var account = props.account;
    var fbaccount = props.fbaccount;

    var handleCommentSubmission = (e) => {
        if (e.key === "Enter") {
            if (!enteredText.length) {
                return;
            }
            console.log("press");
            var comment = {
                id: uuidv4(),
                timestamp: new Date(),
                user: {
                    uid: account.accountIdentifier,
                    name: account.name
                },
                message: enteredText
            };
            comments.push(comment);
            //Add New Comment in Firebase Post Doc
            database.collection(firebaseCollections.thewall).doc(post.id).update({ comments }).then(function () {
                console.log("Finished adding a new comment to a feedback post in firebase db.");
            })
                .catch(function (error) {
                    console.error("Error adding document: ", error);
                });
            setEnteredText("");
        }
    }

    return (
        <div className="Comments">
            <hr style={{ margin: 0, borderTopWidth: '1px' }} />
            <hr style={{ margin: 0, borderTopWidth: '5px', opacity: 0.2 }} />
            {
                props.permittedtocomment ?
                    <div className="Comments--AddNewCommentForm">
                        <Avatar name={props.account.name} round={true} textSizeRatio={2.5} size="32px" color="White" maxInitials={2} className="AppNavbar--Profile-Container--Avatar" />
                        <input value={enteredText} className="Comments--AddNewCommentForm--Input" type="text" placeholder="Enter a comment..." onChange={(e) => { setEnteredText(e.currentTarget.value) }} onKeyPress={handleCommentSubmission} />
                    </div> : null
            }
            <div className="Comments--Comments-Container">
                {
                    comments.map((comment, index) => {
                        return <Comment key={index} post={post} comments={comments} comment={comment} account={account} fbaccount={fbaccount} />;
                    })
                }

            </div>
        </div>
    )
}
